/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { isMobile } from 'react-device-detect'
import { Badge } from 'antd-mobile'
import { GlobalStoreKey } from '@v2/constants/common'
// css
import { Button } from '@styles/button.style'
import { BadgeStyle } from '@styles/base.style'
import { MessageAlertWrapper } from './index.style'

const MessageArrivalButton: React.FC = () => {
  const { globalStore, userStore, messageStore, componentStore } = useRootStore()
  const { notificationData } = userStore

  const imageUrl = globalStore.findGlobalSetting(GlobalStoreKey.INGAME_IMAGES_URL).value
  const version = globalStore.getIngameImagesVersion()
  // img
  const messageShadowImg = `${imageUrl}bg/season_bg/common/message-alert-shadow.png${version}`
  // UI 테마 - default
  const messageCharacter = `${imageUrl}bg/season_bg/default/message-alert-character.png${version}`
  const messageBallImg = `${imageUrl}bg/season_bg/default/message-ball.png${version}`
  const messageCharacterHands = `${imageUrl}bg/season_bg/default/message-alert-character-hands.png${version}`
  const messageBodyImg = `${imageUrl}bg/season_bg/default/message-alert-body.png${version}`
  const messageOpenedBodyImg = `${imageUrl}bg/season_bg/default/message-alert-body-opened.png${version}`
  const messageHeadImg = `${imageUrl}bg/season_bg/default/message-alert-head.png${version}`
  const messageDecoImg = `${imageUrl}bg/season_bg/default/message-deco.png${version}`
  // UI 테마 - spring
  const springSeasonMessageCharacter = `${imageUrl}bg/season_bg/spring/message-alert-character.png${version}`
  const springSeasonMessageCharacterHands = `${imageUrl}bg/season_bg/spring/message-alert-character-hands.png${version}`
  const springSeasonMessageBallImg = `${imageUrl}bg/season_bg/spring/message-ball.png${version}`
  const springSeasonMessageBodyImg = `${imageUrl}bg/season_bg/spring/message-alert-body.png${version}`
  const springSeasonMessageHeadImg = `${imageUrl}bg/season_bg/spring/message-alert-head.png${version}`
  const springSeasonMessageDecoImg = `${imageUrl}bg/season_bg/spring/message-deco.png${version}`
  // UI 테마 - summer
  const summerSeasonMessageCharacter = `${imageUrl}bg/season_bg/summer/message-alert-character.png${version}`
  const summerSeasonMessageCharacterHands = `${imageUrl}bg/season_bg/summer/message-alert-character-hands.png${version}`
  const summerSeasonMessageBallImg = `${imageUrl}bg/season_bg/summer/message-ball.png${version}`
  const summerSeasonMessageBodyImg = `${imageUrl}bg/season_bg/summer/message-alert-body.png${version}`
  const summerSeasonMessageHeadImg = `${imageUrl}bg/season_bg/summer/message-alert-head.png${version}`
  const summerSeasonMessageDecoImg = `${imageUrl}bg/season_bg/summer/message-deco.png${version}`
  // UI 테마 - fall
  const fallSeasonMessageCharacter = `${imageUrl}bg/season_bg/fall/message-alert-character.png${version}`
  const fallSeasonMessageCharacterHands = `${imageUrl}bg/season_bg/fall/message-alert-character-hands.png${version}`
  const fallSeasonMessageBallImg = `${imageUrl}bg/season_bg/fall/message-ball.png${version}`
  const fallSeasonMessageBodyImg = `${imageUrl}bg/season_bg/fall/message-alert-body.png${version}`
  const fallSeasonMessageHeadImg = `${imageUrl}bg/season_bg/fall/message-alert-head.png${version}`
  const fallSeasonMessageDecoImg = `${imageUrl}bg/season_bg/fall/message-deco.png${version}`
  // UI 테마 - winter
  const christmasSeasonMessageCharacter = `${imageUrl}bg/season_bg/winter/message-alert-character.png${version}`
  const christmasSeasonMessageCharacterHands = `${imageUrl}bg/season_bg/winter/message-alert-character-hands.png${version}`
  const christmasSeasonMessageBallImg = `${imageUrl}bg/season_bg/winter/message-ball.png${version}`
  const christmasSeasonMessageBodyImg = `${imageUrl}bg/season_bg/winter/message-alert-body.png${version}`
  const christmasSeasonMessageHeadImg = `${imageUrl}bg/season_bg/winter/message-alert-head.png${version}`
  const christmasSeasonMessageDecoImg = `${imageUrl}bg/season_bg/winter/message-deco.png${version}`
  // UI 테마 - etc_event
  const etcEventMessageCharacter = `${imageUrl}bg/season_bg/etc_event/message-alert-character.png${version}`
  const etcEventMessageCharacterHands = `${imageUrl}bg/season_bg/etc_event/message-alert-character-hands.png${version}`
  const etcEventMessageBallImg = `${imageUrl}bg/season_bg/etc_event/message-ball.png${version}`
  const etcEventMessageBodyImg = `${imageUrl}bg/season_bg/etc_event/message-alert-body.png${version}`
  const etcEventMessageHeadImg = `${imageUrl}bg/season_bg/etc_event/message-alert-head.png${version}`
  const etcEventMessageDecoImg = `${imageUrl}bg/season_bg/etc_event/message-deco.png${version}`

  let timer = null

  const onClickMessageToggleButton = async () => {
    clearTimeout(timer)
    timer = setTimeout(async () => {
      await messageStore.getOneUnQuickReadMessageByUserId()
      const { unQuickReadUserMessage } = messageStore

      if (unQuickReadUserMessage) {
        componentStore.setExtraClubId(null)
        globalStore.setVisibleQuickMessagePopup(true)
      } else {
        userStore.decreaseUnQuickReadMessageCount()
        userStore.decreaseUnReadMessageCount()
      }
    }, 500)
  }


  const makeMessageWrapperClassName = (): string => {
    const baseClass = isMobile ? 'message-wrapper' : 'message-wrapper pc'
    if (notificationData?.unQuickReadMessageCount > 0 && !globalStore.visibleTutorialPopup
      && !globalStore.visibleMatchFilterPopup) {
      return baseClass
    }
    return 'adv-hidden'
  }

  const messageShadowImgUrl = messageShadowImg // 공통된 그림자 이미지에셋 사용

  const uiThemeKey = globalStore.getUiThemeSetting()
  let messageCharacterImgUrl: string
  let messageCharacterHandsImgUrl: string
  let messageBodyImgUrl: string
  let messageHeadImgUrl: string
  let messageBallImgUrl: string
  let messageDecoImgUrl: string

  switch (uiThemeKey) {
    case 'default': // 기본
      messageCharacterImgUrl = messageCharacter
      messageCharacterHandsImgUrl = messageCharacterHands
      messageBodyImgUrl = globalStore.visibleQuickMessagePopup ? messageOpenedBodyImg : messageBodyImg
      messageHeadImgUrl = messageHeadImg
      messageBallImgUrl = messageBallImg
      messageDecoImgUrl = messageDecoImg
      break
    case 'spring': // 벚꽃(봄)
      messageCharacterImgUrl = springSeasonMessageCharacter
      messageCharacterHandsImgUrl = springSeasonMessageCharacterHands
      messageBodyImgUrl = springSeasonMessageBodyImg
      messageHeadImgUrl = springSeasonMessageHeadImg
      messageBallImgUrl = springSeasonMessageBallImg
      messageDecoImgUrl = springSeasonMessageDecoImg
      break
    case 'summer': // 여름
      messageCharacterImgUrl = summerSeasonMessageCharacter
      messageCharacterHandsImgUrl = summerSeasonMessageCharacterHands
      messageBodyImgUrl = summerSeasonMessageBodyImg
      messageHeadImgUrl = summerSeasonMessageHeadImg
      messageBallImgUrl = summerSeasonMessageBallImg
      messageDecoImgUrl = summerSeasonMessageDecoImg
      break
    case 'fall': // 가을
      messageCharacterImgUrl = fallSeasonMessageCharacter
      messageCharacterHandsImgUrl = fallSeasonMessageCharacterHands
      messageBodyImgUrl = fallSeasonMessageBodyImg
      messageHeadImgUrl = fallSeasonMessageHeadImg
      messageBallImgUrl = fallSeasonMessageBallImg
      messageDecoImgUrl = fallSeasonMessageDecoImg
      break
    case 'winter': // 크리스마스(겨울)
      messageCharacterImgUrl = christmasSeasonMessageCharacter
      messageCharacterHandsImgUrl = christmasSeasonMessageCharacterHands
      messageBodyImgUrl = christmasSeasonMessageBodyImg
      messageHeadImgUrl = christmasSeasonMessageHeadImg
      messageBallImgUrl = christmasSeasonMessageBallImg
      messageDecoImgUrl = christmasSeasonMessageDecoImg
      break
    case 'etc_event': // 기타 이벤트
      messageCharacterImgUrl = etcEventMessageCharacter
      messageCharacterHandsImgUrl = etcEventMessageCharacterHands
      messageBodyImgUrl = etcEventMessageBodyImg
      messageHeadImgUrl = etcEventMessageHeadImg
      messageBallImgUrl = etcEventMessageBallImg
      messageDecoImgUrl = etcEventMessageDecoImg
      break
    default:
      messageCharacterImgUrl = messageCharacter
      messageCharacterHandsImgUrl = messageCharacterHands
      messageBodyImgUrl = messageBodyImg
      messageHeadImgUrl = messageHeadImg
      break
  }

  return (
    <MessageAlertWrapper className={makeMessageWrapperClassName()}>
      {/* 버튼을 눌러 메시지 미리보기 모달이 호출 될 시 Button에 'open' class를 추가해주시면 됩니다. */}
      <Button className={`message-alert-btn ${globalStore.visibleQuickMessagePopup ? 'open' : ''}`}
              onClick={onClickMessageToggleButton}>
        <div className="bubble-message">
          읽지 않은 메시지가 있습니다.
        </div>
        <img src={messageCharacterImgUrl} alt="메세지 캐릭터" className="message-alert-character"/>
        <div className="message-ball">
          <img src={messageBallImgUrl} alt="메세지 볼 배경" className="message-ball-bg"/>
          <span className="message-ico">
            <img src={messageBodyImgUrl} alt="메세지" className="message-body"/>
            <img src={messageShadowImgUrl} alt="메세지" className="message-shadow"/>
            <img src={messageHeadImgUrl} alt="메세지" className="message-head"/>
            <img src={messageDecoImgUrl} alt="메세지 장식" className="message-deco"/>
          </span>
          <img src={messageCharacterHandsImgUrl} alt="메세지 캐릭터 손" className="message-alert-character-hands"/>
          <Badge text={notificationData?.unQuickReadMessageCount || 0} overflowCount={99} css={BadgeStyle}
                 className="badge-style"/>
        </div>
      </Button>
    </MessageAlertWrapper>

  )
}

export default observer(MessageArrivalButton)
